import React from "react";
import { pickLocale } from "../../lib/format";
import { useI18n } from "../../lib/i18n";

/**
 * The service notice above the header.
 *
 * Deliberately quiet: a luxury house states its delivery terms, it does not
 * advertise them. Small caps, wide tracking, ink ground — read once and then
 * ignored, which is why it scrolls away rather than holding a sticky row.
 */
export default function AnnouncementBar({ text }) {
  const { locale } = useI18n();
  const copy = pickLocale(text, locale);
  if (!copy) return null;
  return (
    <div className="bg-[var(--adf-ink)] text-[var(--adf-white-warm)]" data-testid="announcement-bar">
      <div className="adf-container adf-announce">{copy}</div>
    </div>
  );
}
